const RightArrowUpwordIcon = ({ height = 15, width = 13, className }) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.29214 0C7.33239 3.0621e-05 7.37261 0.00397016 7.41226 0.0117188C7.44503 0.0181094 7.47626 0.0287463 7.50698 0.0400391C7.51363 0.0424788 7.52091 0.0432256 7.52749 0.0458984C7.54743 0.0540128 7.56528 0.0661212 7.58413 0.0761719C7.60334 0.0864025 7.62348 0.0950475 7.64175 0.107422C7.7427 0.175714 7.82211 0.272746 7.86929 0.386719C7.87452 0.399431 7.87763 0.412816 7.88198 0.425781C7.90322 0.488589 7.91713 0.555034 7.91714 0.625V7.29199C7.91696 7.63691 7.63706 7.91682 7.29214 7.91699C6.94711 7.91694 6.66732 7.63699 6.66714 7.29199V2.13379L1.06753 7.7334C0.823452 7.97748 0.426842 7.97748 0.182765 7.7334C-0.0608343 7.48934 -0.0610086 7.09356 0.182765 6.84961L5.78237 1.25H0.625147C0.28001 1.24995 0.000147343 0.970149 0.000147343 0.625C0.000207366 0.279902 0.280047 4.7399e-05 0.625147 0H7.29214Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RightArrowUpwordIcon;
